var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudPrimaryMd = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 180,
  height: 136,
  fill: "none",
  viewBox: "0 0 180 136",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 64,
  r: 64,
  fill: "var(--utility-brand-200, black)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 20,
  r: 6,
  fill: "var(--utility-brand-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 112,
  r: 8,
  fill: "var(--utility-brand-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 36,
  r: 8,
  fill: "var(--utility-brand-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 9,
  r: 5,
  fill: "var(--utility-brand-100, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-50, black)",
  fillRule: "evenodd",
  d: "M92 16c-13.466 0-25.378 6.654-32.627 16.854A32 32 0 0 0 52 32c-17.673 0-32 14.327-32 32s14.327 32 32 32h80c15.464 0 28-12.536 28-28s-12.536-28-28-28a28 28 0 0 0-3.248.186C122.623 25.96 108.475 16 92 16",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 64,
  r: 32,
  fill: "url(#b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 56,
  r: 40,
  fill: "url(#c)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 68,
  r: 28,
  fill: "url(#d)"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-400, black)",
  d: "M62 88c0-15.464 12.536-28 28-28s28 12.536 28 28-12.536 28-28 28-28-12.536-28-28"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m100.5 98.5-4.083-4.083m2.916-7c0 5.477-4.44 9.916-9.916 9.916-5.477 0-9.917-4.44-9.917-9.916 0-5.477 4.44-9.917 9.917-9.917s9.916 4.44 9.916 9.917"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 27.429,
  x2: 84,
  y1: 42.857,
  y2: 96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9D7FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-brand-200, black)",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 61.286,
  x2: 132,
  y1: 29.571,
  y2: 96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9D7FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-brand-200, black)",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 110.5,
  x2: 160,
  y1: 49.5,
  y2: 96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E9D7FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.351,
  stopColor: "var(--utility-brand-200, black)",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 180,
  height: 120,
  x: 0,
  y: 16,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect1_dropShadow_1182_1077"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1182_1077"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect2_dropShadow_1182_1077"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1182_1077",
  result: "effect2_dropShadow_1182_1077"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_1182_1077",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "e",
  width: 72,
  height: 72,
  x: 54,
  y: 52,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1182_1077"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1182_1077",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudPrimaryMd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CloudPrimaryMd.1dcb40f8a182ce0141a117d6ae82eea6.svg";